import { render, staticRenderFns } from "./ModalExibirCronometroTarja.vue?vue&type=template&id=2b593c66"
import script from "./ModalExibirCronometroTarja.vue?vue&type=script&lang=js"
export * from "./ModalExibirCronometroTarja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports